import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const SPEAKERS = <><b>Introduction:</b> Paul Morris, Ex-Head of Growth Advisory, BDO · <b>Main speaker:</b> Neil Foster, Global Co-Chair of Technology Sector, Brown Rudnick LLP — Neil advises on around 100 VC deals a year.</>;

const EVENTS = [
    {
        day: '03', month: 'Sep', title: 'StartuptoStandup Founders Walk',
        body: <>Join us for a walk around Serpentine Lake, Hyde Park. No agendas, no pitching — just founders walking, talking and connecting. Meet Ollie at the Lodge Cafe by the Hyde Park corner at 1pm. <a href="https://luma.com/5ezics6h" target="_blank" rel="noopener noreferrer">Register here</a>.</>,
        meta: 'Hyde Park, London · In person · 1:00pm',
    },
    {
        day: '11', month: 'Sep', title: 'Webinar: The Top 10 Most Predictable Transaction Mistakes',
        to: ROUTES.TOP_TEN_TRANSACTION_MISTAKES,
        body: 'A look at the recurring, avoidable mistakes that trip up deals — and how to spot them before they cost you.',
        speakers: SPEAKERS, meta: 'Online · Webinar · 12:00pm',
    },
    {
        day: '16', month: 'Oct', title: 'Webinar: Series A Termsheet — What VCs Really Want',
        body: "An honest look at term sheets from the investor side of the table, so you know what's negotiable and what isn't.",
        speakers: SPEAKERS, meta: 'Online · Webinar · 12:00pm',
    },
    {
        day: '20', month: 'Nov', title: 'Webinar: Founder Mentors? The Good, the Bad and the Ugly',
        body: "What makes a mentor relationship actually work — and the warning signs to walk away from one that won't.",
        speakers: SPEAKERS, meta: 'Online · Webinar · 12:00pm',
    },
];

const CommunityEventsSection = () => (
    <>
        <section className="lp-cm-events-hero">
            <div className="lp-cm-events-hero-inner">
                <div>
                    <span className="lp-cm-eyebrow" data-lp-reveal><span className="dot" />Events</span>
                    <h1 className="lp-cm-events-h1" data-lp-reveal data-lp-delay="60">Where the community meets, in person.</h1>
                    <p className="lp-cm-lead" data-lp-reveal data-lp-delay="120">Roundtables, demo nights and founder dinners — the same people from the ecosystem, just in the same room.</p>
                </div>
                <img className="lp-cm-events-art" src={require('../../../../images/landing-pages/community/events-header.webp')} alt="Community event" data-lp-reveal data-lp-delay="160" />
            </div>
        </section>

        <section className="lp-cm-events-list">
            <div className="lp-cm-events-list-inner">
                {EVENTS.map((e, i) => (
                    <div className="lp-cm-event" key={e.title} data-lp-reveal data-lp-delay={i * 80}>
                        <div className="lp-cm-event-date">
                            <span className="d">{e.day}</span>
                            <span className="m">{e.month}</span>
                        </div>
                        <div>
                            <h3>{e.to ? <Link to={e.to}>{e.title}</Link> : e.title}</h3>
                            <p>{e.body}</p>
                            {e.speakers && <span className="lp-cm-event-speakers">{e.speakers}</span>}
                            <span className="lp-cm-event-meta">{e.to ? <Link to={e.to}>{e.meta}</Link> : e.meta}</span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    </>
);

export default CommunityEventsSection;
